import List from '../../../utils/list';

const mutation = {
  initalReset(state, data) {
    state.all = data;
    state.filter = {};
    state.filter.page = 1;
    state.filter.query = null;
    state.hasEmpty = false;
  },
  setSearchTerm(state, data) {
    state.filter[data.column] = data.query;
  },
  setFilter(state, data) {
    state.filter = data;
  },
  setShowDetails(state, { id, data }) {
    const fetchData = state.all.find(mdm => mdm.id === id);
    if (fetchData) {
      fetchData.users = data;
    }
  },
  setShowLoading(state, status) {
    state.isShowLoading = status;
  },
  resetAll(state, data) {
    state.all = data;
  },
  setPage(state, page) {
    state.filter.page = page;
  },
  setExcludeVehicles(state, data) {
    state.excludeList = data;
  },
  setQuery(state, query) {
    state.filter.query = query;
  },

  setLoadingStatus(state, status) {
    state.isLoading = status;
  },
  setuploadStatus(state, status) {
    state.isUploading = status;
  },

  changesCheck(state, status) {
    state.isUpdating = status;
  },
  setDownloadStatus(state, status) {
    state.isDownloading = status;
  },
  updateExisting(state, { data }) {
    const result = List.update(state.all, data);
    state.all = result;
  },
  appendNew(state, { data }) {
    const result = List.new(state.all, data);
    state.all = result;
  },
  setAll(state, data) {
    const result = (state.filter.page > 1) ? state.all.concat(data) : data;
    state.all = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },

  setSlab(state, data) {
    const result = (state.filter.page > 1) ? state.slabData.concat(data) : data;
    state.slabData = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  paginationCheck(state, status) {
    if (status) {
      state.hasEmpty = status;
    }
    state.isPaginating = status;
  },
  setGST(state, data) {
    state.gstList = data;
  },
  setExceptionList(state, data) {
    state.exceptionList = data;
  },
  setCurrentBdr(state, data) {
    state.currentBdr = data;
  },
  setDedicatedTruckHistory(state,data)
  {
    state.dedicatedTruckHistory=data;
  },
  setHeader(state, data) {
    state.header = data;
  },
  setBdrSlabs(state, data) {
    state.bdrSlabs = data;
  },
};


export default mutation;
